import { render } from "./newPasswordForm.vue?vue&type=template&id=262b39ee&ts=true"
import script from "./newPasswordForm.vue?vue&type=script&lang=ts"
export * from "./newPasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__